/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import PhotoFrame from 'components/molecules/PhotoFrame';
import { StaffInfo } from 'domain/attend/shiftBoard/types';
import { mock } from './styles';

/**
 * シフト表のスタッフアイコン（勤務スケジュールと同じ顔写真）
 *
 * 写真が無いときは PhotoFrame が既定アイコンに切り替える。
 * 支援受入・違反の区別は写真のまわりの輪で示す。
 */
export type StaffAvatarProps = {
  staff: StaffInfo;
  /** 一覧の再描画で画像を取り直さないよう、呼び出し側で作った URL を渡す */
  src: string;
  hasViolation?: boolean;
  size?: number;
};

const wrap = (size: number, ring: string) => css({
  width: `${size}px`,
  height: `${size}px`,
  borderRadius: '9999px',
  flex: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  boxShadow: `0 0 0 1.5px ${ring}`,
  background: mock.gray10,
});

const StaffAvatar: React.FC<StaffAvatarProps> = ({
  staff, src, hasViolation = false, size = 22,
}) => {
  let ring = mock.primaryM80;
  if (hasViolation) {
    ring = mock.secondary;
  } else if (staff.isGuest) {
    ring = mock.guestText;
  }
  return (
    <div css={wrap(size, ring)} title={staff.staffName}>
      <PhotoFrame src={src} size={`${size}px`} isCircle={true} onErrorIconColor={mock.gray40} />
    </div>
  );
};

export default StaffAvatar;
